// components/NotFound.js
import React from "react"
import deniewImg from "./assets/images/AccessDenied.jpg"
import ConfigUrl from "./config"
import { Card } from "reactstrap"
import { Link } from "react-router-dom"

const NotFound = () => (
  <Card>
    <div className="text-center py-5 bg-white h-100">
      <div>
        <img src={deniewImg} alt="" height={400} />
      </div>
      <div>
        <Link
          to={`${ConfigUrl?.appurl}`}
          className="btn btn-primary px-4 py-2 fs-5 bg-blue "
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  </Card>
)

export default NotFound
